<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >

    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <v-layout>
          <v-flex
            xs12
            md2
            class="masterDropdown">
            <v-select
              v-model="initmaster"
              :items="masterlists"
              item-value="value"
              solo
              @change="onChange"
            />
          </v-flex>
          <v-flex offset-md9>
            <v-btn
              :loading="isDownloading"
              :disabled="isDownloading"
              class="white--text"
              @click="loader = 'isDownloading'"
            >
              <download-csv
                :data="filteredAccounts"
                name="csv.csv">
                Extract
              </download-csv>
            </v-btn>
            <v-snackbar
              v-model="downloadSuccess"
            >
              Excel Downloaded
              <v-btn
                @click="downloadSuccess = false"
              >
                Close
              </v-btn>
            </v-snackbar>
          </v-flex>
        </v-layout>

        <material-card
          color="orange"
          title="Account Inventory"
          text="List of AWS accounts"
        >
          <v-layout
            justify-center
            wrap>

            <v-flex
              xs12
              sm3
              md3
              offset-md9>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="headers"
            :items="items"
            :search ="search"
            :pagination.sync="pagination"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <td>{{ item.account_name }}</td>
              <td>{{ item.account_dl }}</td>
              <td>
                <!-- {{ item.account_id }} -->
                <v-dialog
                  v-model="dialog"
                  width="600">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      id="data-link"
                      v-on="on">{{ item.account_id }}</v-btn>
                  </template>

                  <v-card>
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title>Account Information</v-card-title>
                    <v-form>
                      <v-container>
                        <span
                          v-show="onHide"
                          id="acctEdited">Account has been updated!</span>
                        <v-text-field
                          v-model="item.account_name"
                          label="Account Name"/>
                        <v-text-field
                          v-model="item.account_dl"
                          label="Account DL"/>
                        <v-text-field
                          v-model="item.account_id"
                          label="Account ID"/>
                        <v-text-field
                          v-model="item.region"
                          label="Region"/>
                        <v-text-field
                          v-model="item.aws_sppt"
                          label="AWS Sppt"/>
                        <v-text-field
                          v-model="item.dxc_sppt"
                          label="DXC Sppt"/>
                      </v-container>
                    </v-form>

                    <v-divider/>

                    <v-card-actions>
                      <v-spacer/>
                      <v-btn
                        color="primary"
                        flat
                        @click="save">Save</v-btn>
                      <v-btn
                        color="primary"
                        flat
                        @click="closeDialog">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td>{{ item.region }}</td>
              <td>{{ item.aws_sppt }}</td>
              <td>{{ item.dxc_sppt }}</td>

            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>

        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    loader: null,
    isDownloading: false,
    downloadSuccess: false,
    search: '',
    pagination: {
      descending: true,
      page: 2,
      rowsPerPage: 3,
      sortBy: 'customer_name',
      totalItems: 6
    },
    // start masterpayer list
    initmaster: 'All',
    masterlists: [
      {
        text: 'Customer 1'
      },
      {
        text: 'Customer 2'
      },
      {
        text: 'Customer 3'
      },
      {
        text: 'Customer 4'
      },
      {
        text: 'Customer 5'
      },
      {
        text: 'All'
      }
    ],
    // end masterpayer list
    headers: [
      {
        sortable: true,
        text: 'Account Name',
        value: 'account_name'
      },
      {
        sortable: true,
        text: 'Account DL',
        value: 'account_dl',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Account ID',
        value: 'account_id',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Region',
        value: 'region',
        align: 'left'
      },
      {
        sortable: true,
        text: 'AWS Sppt',
        value: 'aws_sppt',
        align: 'left'
      },
      {
        sortable: true,
        text: 'DXC Sppt',
        value: 'dxc_sppt',
        align: 'left'
      }
    ],

    items: [
      {
        account_name: 'aws-spp-acme-prod1-italy',
        account_dl: 'aws-spp-acme-prod1-italy@cloud.dxc.com',
        account_id: '123456789123',
        region: 'SE',
        aws_sppt: 'Business',
        dxc_sppt: 'Gold'
      },
      {
        account_name: 'aws-spp--nero-sb-japan',
        account_dl: 'aws-spp--nero-sb-japan@cloud.dxc.com',
        account_id: '001122334455',
        region: 'Asia',
        aws_sppt: 'Enterprise',
        dxc_sppt: 'Gold'
      },
      {
        account_name: 'aws-spp--nero-sb-neworleans',
        account_dl: 'aws-spp--nero-sb-neworleans@cloud.dxc.com',
        account_id: '001122334456',
        region: 'NA',
        aws_sppt: 'Enterprise',
        dxc_sppt: 'Gold'
      },
      {
        account_name: 'aws-spp--nero-sb-india',
        account_dl: 'aws-spp--nero-sb-india@cloud.dxc.com',
        account_id: '001122334456',
        region: 'Asia',
        aws_sppt: 'Enterprise',
        dxc_sppt: 'Gold'
      },
      {
        account_name: 'aws-spp--nero-sb-china',
        account_dl: 'aws-spp--nero-sb-china@cloud.dxc.com',
        account_id: '001122334456',
        region: 'Asia',
        aws_sppt: 'Enterprise',
        dxc_sppt: 'Gold'
      },
      {
        account_name: 'aws-spp--nero-sb-china',
        account_dl: 'aws-spp--nero-sb-china@cloud.dxc.com',
        account_id: '001122334456',
        region: 'Asia',
        aws_sppt: 'Enterprise',
        dxc_sppt: 'Gold'
      }
    ],
    dialog: false,
    onHide: false
  }),
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => {
        this[l] = false
        this.downloadSuccess = true
      }, 3000)
      this.loader = null
    }
  },
  methods: {
    save () {
      this.onHide = true
      this.dialog = false
    },
    closeDialog: function () {
      console.log('close dialog 1')
      this.dialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}
.v-btn .v-btn__content {
  color: rgba(0, 0, 0, 0.87);
  background-color: none;
  box-shadow: none;
  font-weight: 500;
}
#data-link {
  background-color: none;
  box-shadow: none;
  padding: 0;
  font-weight: 600;
}
.masterDropdown{
  margin-bottom:0 ;
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot{
  background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
  color:#fff !important;
}
.theme--light.v-select .v-select__selections{
  color:#fff !important;
}
  .theme--light.v-icon{
    color:#fff;
  }
}

</style>
